import React, { useState } from 'react';

function ImageViewer({ setShowImageViewer, missionData })
{
  const [viewerWillBeClosed, setViewerWillBeClosed] = useState(false);

  const handleCloseBook = () => {
    setViewerWillBeClosed(true);
    setTimeout(() => {
      setShowImageViewer(false);
    }, 700);
  }
  return (
    <div className={`image-viewer-wrapper ${viewerWillBeClosed ? 'animateOut' : ''}`}>
      <div className="image-viewer">
        <iframe class="image-frame" src={`/app/aFrameViewer/${missionData.book_page.id}`} width="100%" height="100%" />
      </div>
      <div className="buttonCloseImageViewer" onClick={ e => {handleCloseBook()}}>
        <div className='icon'></div>
        <div className='caption'>Sluiten</div>
        <div className='backgroundFX'><div class="FXLayer"></div></div>
      </div>
    </div>
  );
}

export default ImageViewer;